module.exports = __webpack_public_path__ + "img/gtzy1_zhCn.b68dec4e.png";